import { useParams } from "react-router-dom";
import useFetch from "./fetch";
import { useNavigate } from "react-router-dom";
const BlogDetails = () => {
    const { id } = useParams();
    const {Data : blog,isPinding,error} = useFetch('http://localhost:8000/blogs/'+id);
    const navigate = useNavigate();

    const handleClick = ()=>{
      fetch('http://localhost:8000/blogs/'+ blog.id,{
        method :"DELETE"

      }).then(()=>{

        navigate("/");
      });
    }
    return (
        <div className="blog-details">
          { isPinding && <div>Loading...</div> }
          { error && <div>{ error }</div> }
          { blog && 
            <article>
              <h2>{ blog.title }</h2>
              <p>Written by { blog.author }</p>
              <div>{ blog.body }</div>
              <button onClick={handleClick}>Delete</button>
            </article>
          }
        </div>
      );
    }
export default BlogDetails;